var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings_preferences"},[_c('SettingsNotifications',{staticClass:"mb-5"}),_c('SettingsLanguage',{staticClass:"mb-5"}),_c('SettingsUnits')],1)}
var staticRenderFns = []

export { render, staticRenderFns }